import AdvancedQuery from '../../../assets/js/modules/advancedQuery.js';

document.addEventListener( 'DOMContentLoaded', () => {
	Array.from( document.querySelectorAll( '.advanced-query' ) ).map( ( node ) => new AdvancedQuery( node ) );
} );
